<template>
  <validation-observer ref="validationobserver" v-slot="{}">
    <b-form @submit.prevent="salvarEnvioSM" id="editar-envio-sm">
      <b-card header-tag="header" class="m-3" no-body>
        <template #header>
          <h6 class="mb-0 text-center">
            <span class="titulo-sagres font-weight-bold">
              Cadastrar autorização para Envio sem Movimento
            </span>
            <btn-voltar />
            <b-button class="float-right m-1" size="sm" type="submit">
              <font-awesome-icon icon="save" />
              Salvar
            </b-button>
          </h6>
        </template>
        <b-card-body>
          <b-row>
            <b-col cols="12" lg="9">
              <b-form-group label-class="text-center" label="Unidade Gestora" label-for="unidade-gestora">
                <multiselect
                  v-model="envioSM.UnidadeGestora" id="unidade-gestora" open-direction="bottom"
                  :close-on-select="true" :searchable="true" label="Nome" :show-labels="false"
                  deselect-label="" :allow-empty="true" placeholder="Selecione" track-by="Codigo" :options="optionsUG">
                  <template slot="noOptions">
                    <small><i>Erro ao obter dados.</i></small>
                  </template>
                  <template slot="noResult">
                    <i>Sem resultados.</i>
                  </template>
                </multiselect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="9">
                <b-form-group id="input-group-type" label-size="md" label="Sistema">
                  <b-form-select v-model="envioSM.idSistema" :options="comboSistemas">
                  </b-form-select>
                </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="3">
              <validation-provider rules="required" v-slot="validationContext" name="exercicio">
                <b-form-group id="input-group-type" label-size="md" label="Exercício (ano)*">
                  <b-form-select id="select-exercicio" v-model="envioSM.exercicio"
                    :options="comboExercicios" :state="getValidationState(validationContext)">
                  </b-form-select>
                  <b-form-invalid-feedback id="select-exercicio-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="3">
              <b-form-group id="input-group-type" label-size="md" label="Mês inicial">
                <b-form-select id="select-mes-inicial" v-model="envioSM.mesInicial"
                  :options="comboReferencias">
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="3">
              <b-form-group id="input-group-type" label-size="md" label="Mês final">
                <b-form-select id="select-mes-final" v-model="envioSM.mesFinal"
                  :options="comboReferencias">
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-form>
  </validation-observer>
</template>

<script lang="ts">
import { Vue, Component, Ref } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import BtnVoltar from "@/components/shared/BtnVoltar.vue";
import Multiselect from "vue-multiselect";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { store } from "@/store";
import { UtilsTS } from "@/utilsts";
import { SelectValue } from "@/types/select-value";
import enviosSMService from "@/services/administracao/enviosSMService";
import { EnviosSM } from "@/types/administracao/envios-sm";
import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";
import ugService from "@/services/administracao/ugService";

const CompProps = Vue.extend({
  name: "EditarEnviosSM",
  components: {
    BtnVoltar,
    ValidationProvider,
    Multiselect,
    ValidationObserver,
  },
  props: {
    idEnvioSM: {
      type: String,
      required: false,
    },
  },
});

@Component
export default class EditarEnviosSM extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  comboExercicios: SelectValue[] = [];
  comboReferencias: SelectValue[] = [];
  comboSistemas: SelectValue[] = [];
  envioSM = new EnviosSM();
  optionsUG: UnidadeGestoraResumida[] = [];
  isBusy = false;

  async mounted(): Promise<void> {
    try {
      store.blockScreen = true;
      await this.obterUgsAtivas();
      this.envioSM.idSistema = 0;
      this.envioSM.exercicio = 0;
      this.envioSM.mesInicial = 0;
      this.envioSM.mesFinal = 0;
      await this.obterSistemas();
      const ano = new Date().getFullYear();
      this.comboExercicios = [
        { text: String(ano - 2), value: ano - 2 },
        { text: String(ano - 1), value: ano - 1 },
        { text: String(ano), value: ano },
        { text: String(ano + 1), value: ano + 1 },
      ];
      this.comboReferencias = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
      ].map((r) => {
        return { text: String(r), value: r };
      });
    } catch (e: any) {
      console.error("Erro ao montar edição de envios SM", e);
      this.$router.push("/seguranca-administracao/envios-sem-movimento");
      this.$toast.error(e.message || "Erro ao carregar envio SM");
    } finally {
      store.blockScreen = false;
    }
  }

  async obterSistemas(): Promise<void> {
    try {
      const response = await enviosSMService.buscarSistemas();
      if (response && response.status === 200) {
        this.comboSistemas = response.data.map((r) => {
          return { text: r.Descricao, value: r.IdSistema };
        });
      } else {
        throw new Error(
          response.data && response.data.msg
            ? response.data.msg
            : "Ocorreu um erro ao buscar sistemas!"
        );
      }
    } catch (e: any) {
      console.error(e);
      this.$toast.error(e.message ? e.message : e);
    } finally {
      this.isBusy = false;
    }
  }

  async obterUgsAtivas(): Promise<void> {
    try {
      const response = await ugService.obterUgsAtivas();
      if (response && response.status === 200) {
        this.optionsUG = this.formatedUGLabels(response.data);
      } else {
        throw new Error(
          response.data && response.data.msg
            ? response.data.msg
            : "Ocorreu um erro ao buscar UGs ativas!"
        );
      }
    } catch (e: any) {
      console.error(e);
      this.$toast.error(e.message ? e.message : e);
    } finally {
      this.isBusy = false;
    }
  }

  async salvarEnvioSM(): Promise<void> {
    try {
      store.blockScreen = true;
      const isValid = await this.validationobserver.validate();
      if (!isValid) {
        console.error(this.validationobserver);
        return;
      }
      const response = await enviosSMService.adicionarEnviosSM(this.envioSM);
      if (response && response.status == 200) {
        this.$toast.success(`Envio Sem Movimento cadastrado com sucesso!`);
        this.$router.push("/seguranca-administracao/envios-sem-movimento");
      } else if (response && response.data.msg) {
        this.$toast.error(
          response.data.msg || "Erro ao salvar Envio Sem Movimento"
        );
      } else {
        this.$toast.error("Erro ao salvar Envio Sem Movimento(1)");
      }
    } catch (e: any) {
      console.error("Erro ao salvar Envio Sem Movimento(2)", e, this.envioSM);
      this.$toast.error(
        e.response?.data.msg || "Erro ao salvar Envio Sem Movimento(3)"
      );
    } finally {
      store.blockScreen = false;
    }
  }

  getValidationState({ dirty, validated, valid = null }): any {
    return dirty || validated ? valid : null;
  }
}
</script>

<style>
.multiselect {
  width: 100%;
}
</style>
